import { jsxs as r, jsx as c } from "react/jsx-runtime";
import { SvgIcon as t } from "../SvgIcon.js";
const s = (o) => /* @__PURE__ */ r(t, { ...o, children: [
  /* @__PURE__ */ c("path", { d: "M5.98886 5.75699c-.32044.32045-.32044.85083 0 1.18232.32044.32044.85083.32044 1.18232 0 .32044-.32044.32044-.85082 0-1.18232-.33149-.32044-.86188-.32044-1.18232 0Z" }),
  /* @__PURE__ */ c("path", { d: "M10 0C4.47514 0 0 4.47513 0 9.99999 0 15.5249 4.47514 20 10 20c5.5249 0 10-4.4751 10-10.00001C20 4.47513 15.5249 0 10 0Zm6.6409 11.5912-4.8177 4.8176c-.3646.3647-.9613.3647-1.326 0l-5.83422-5.8342c-.17679-.1768-.27624-.4199-.27624-.663V5.24861c0-.60773.48619-1.09391 1.09392-1.09391h4.66294c.2542 0 .4862.09945.663.27624l5.8343 5.83426c.3646.3646.3646.9613 0 1.326Z" })
] });
export {
  s as Tags
};
//# sourceMappingURL=Tags.js.map
